module.exports = __webpack_public_path__ + "static/media/object.c0c169b1.gif";